import 'shared/styles/global.scss';
import { setup } from 'shared/libs/axios';

// @ts-ignore
// const config = {
//   url: `${process.env.REACT_APP_DOMAIN}/tsp-api/api/front`
// }

// const ENV = {
//   dev: {
//     baseURL: config? config.url : 'http://dev-portal.atops.or.kr/tsp-api/api/front'
//   },
//   prod: {
//     baseURL: config? config.url : 'http://dev-portal.atops.or.kr/tsp-api/api/front'
//   }
// }

// const api = {
//   baseURL: 'http://api.bnet.com',
// };
// @ts-ignore
// const api = process.env.REACT_APP_MODE? ENV[process.env.REACT_APP_MODE] : ENV['dev'];

const api = {
  baseURL: `${process.env.REACT_APP_API}`
};

setup(api);
export default { config: { api } };

// 3.37.6.42
